// Single source of truth for the campaign's modules and their nav entries.
//
// Previously this list was duplicated in TabNav.jsx and MobileSidebar.jsx and the
// two copies had drifted. Both now render from here.
//
// `id` values must match the server's module keys exactly — see
// functions/api/campaigns.js. `overview` is NOT a server-side module: it is the
// landing page a campaign URL resolves to and is always on.

export const ALWAYS_ON = ['overview'];

export const MODULES = [
  { id: 'overview',  icon: '🏠',  label: 'Overview',        sidebarLabel: 'Overview',        nav: true },
  { id: 'character', icon: '🎭',  label: 'My Character',    sidebarLabel: 'My Character',    nav: true },
  { id: 'quests',    icon: '⚔️',  label: 'Quests',          sidebarLabel: 'Quests',          nav: true, countKey: 'quests' },
  { id: 'locations', icon: '🗺️',  label: 'Locations',       sidebarLabel: 'Locations',       nav: true, countKey: 'locations' },
  { id: 'npcs',      icon: '👥',  label: 'NPCs\n& Factions', sidebarLabel: 'NPCs & Factions', nav: true, countKey: 'npcs' },
  { id: 'sessions',  icon: '📜',  label: 'Sessions',        sidebarLabel: 'Sessions',        nav: true, countKey: 'sessions' },
  { id: 'items',     icon: '⚗️',  label: 'Items',           sidebarLabel: 'Items',           nav: true, countKey: 'items' },
  // Reached by their own routes rather than the tab bar, but still toggleable.
  { id: 'map',       icon: '🧭',  label: 'Interactive Map', sidebarLabel: 'Interactive Map', nav: false },
  { id: 'feyblood',  icon: '🍄',  label: 'Feyblood',        sidebarLabel: 'Feyblood',        nav: false },
];

export function isModuleEnabled(enabledModules, id) {
  if (ALWAYS_ON.includes(id)) return true;
  if (!Array.isArray(enabledModules)) return false;
  return enabledModules.includes(id);
}

export function visibleTabs(enabledModules) {
  return MODULES.filter((m) => m.nav && isModuleEnabled(enabledModules, m.id));
}
